import Image from 'next/image'
import styles from '../Calendar.module.scss'
import { AssetType } from '~types'

const BackGroundImage = ({ image }: { image: AssetType | undefined }) => {
  return (
    <div className={styles['hero-container__bg-img']}>
      {image?.url && (
        <Image
          src={image?.url}
          alt={image?.altText || ''}
          style={{
            objectFit: 'cover',
            backgroundPosition: 'top center'
          }}
          fill
        />
      )}
    </div>
  )
}

export default BackGroundImage
